import React, { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string;
  name?: string;
  type?: string | number;
}
interface DropdownOptionProps {
  name?: string,
  initialValue?: Option | undefined | null;
  dataList?: Option[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean,
  className?: string,
  classNamePrefix?: string,
  isHasOptionAll?: boolean,
  optionAll?: undefined | Option,
  labelTop?: string,
  style?: any,
  isHaveMoreInfo?: boolean,
  isClearable?: boolean
}

const DropdownOption = ({
  name = '',
  initialValue,
  onChangeSelect,
  dataList = [],
  placeholder,
  disabled = false,
  className = '',
  classNamePrefix = '',
  isHasOptionAll = false,
  optionAll,
  labelTop = '',
  style = {},
  isHaveMoreInfo = false,
  isClearable = false
}: DropdownOptionProps) => {
  const { t } = useTranslation();
  const options = useMemo(() => {
    const resultOptions = dataList?.map((item) => ({ label: item?.label, value: String(item?.value || '') })) || [] as Option[];
    return [{ label: t('All'), value: '' }, ...resultOptions];
  }, [JSON.stringify(dataList)]);

  const handleChange = useCallback((selectedOption: any) => {
    onChangeSelect && onChangeSelect(selectedOption);
  }, [onChangeSelect]);

  return (
    <div className="position-relative" style={style}>
      <Select
        options={options}
        value={initialValue}
        name={name}
        isDisabled={disabled}
        onChange={handleChange}
        placeholder={<div>{placeholder || ''}</div>}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        className={`dropdown-status-rounded ${className}`}
        classNamePrefix={classNamePrefix}
        isClearable={isClearable}
      />
      {labelTop && (initialValue?.value) && (<label style={{
        position: 'absolute',
        left: '5px',
        top: '0px',
        marginBottom: '0px',
        transform: 'translateY(-50%)',
        padding: `0px 5px`,
        color: '#c2c2c2',
        fontSize: '12px',
        fontWeight: '400',
        borderRadius: '3px',
        backgroundColor: disabled ? 'hsl(0, 0%, 95%)' : 'var(--vz-secondary-bg)',
      }}>
        {labelTop}
      </label>)}
    </div>
  );
};

export default React.memo(DropdownOption);
